import React from 'react';
import { parseMarkdown } from '../../lib/markdown';

interface ProviderNoteProps {
  isSmallStyle: boolean;
  providerNote: string;
}

export const ProviderNote: React.FC<ProviderNoteProps> = ({
  isSmallStyle,
  providerNote,
}) => {
  if (isSmallStyle || !providerNote) return null;

  return (
    <div
      className="prose prose-sm mt-4 max-w-none break-words text-caption text-neutral-125"
      dangerouslySetInnerHTML={{ __html: parseMarkdown(providerNote) }}
    />
  );
};
